export const pinValidator = (data) => {
    if (!data.valid) {
        return {
            "valid": false,
            "validationMsg": "Pin Entered is Not Valid."
        }
    } else {
        return {
            "valid": true,
            "validationMsg": "Pin Entered is Valid."
        }
    }
}
export const postalCodeCountryValidator = (formDetails) => {
    if (!formDetails.country && formDetails.zipCode) {
        return {
            "valid": false,
            "validationMsg": "Please select a Country."
        }
    } else if(formDetails.zipCode.length < 3 || formDetails.zipCode.length > 15){
        return {
            "valid": false,
            "validationMsg": "PostalCode should be between 3 to 15 characters length."
        }
    }
}

export const postalCodeApiValidator = (formDetails, data) => {
    if (formDetails.country && formDetails.zipCode && !data) {
        return {
            "valid": true,
            "validationMsg": "No Postal Code Required for selected Country."
        }
    } else if (formDetails.country && formDetails.zipCode && !data.validPostalCd) {
        return {
            "valid": false,
            "validationMsg": "Postal code is Incorrect."
        }
    }
}

export const amountOfUseValidator = (formDetails, props) => {
    const reg = /^-?\d*\.?\d*$/;
    if (formDetails.amountOfUse && !reg.test(formDetails.amountOfUse)) {
        console.log("Non digit values entered in Amount of Use.")
        return {
            "valid": false,
            "validationMsg": "Please enter numeric values only."
        }
    }
}


